module.exports = __webpack_public_path__ + "img/3.2a3a8376.svg";